export default "__VITE_ASSET__hZ1hKs4s__"